var result = require("!!../../../../node_modules/html-loader/index.js?interpolate!./styling_borders.html")
var H = require("hogan.js");
module.exports = function() {
var T = H.compile(result, {});
return T.render.apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./node_modules/mustache-loader!./node_modules/html-loader?interpolate!./src/components/guideline/templates/styling_borders.html
// module id = 97
// module chunks = 0